module.exports = __webpack_public_path__ + "img/vase.759916d2.png";